import importSvgIcons from './importSvgIcons';

export default importSvgIcons(
  require.context(`../../client/assets/brands/chevrolet/svg`, true, /\.svg$/)
);
